// extracted by mini-css-extract-plugin
export default {"showMiniProfileMenu":"MiniProfileMenu_showMiniProfileMenu__1z9Yx"};